import {
  createReducer,
  updateObject,
  updateItemInArray,  
} from 'helpers/ReducerUtil'
import {
  UPDATE_LAYER_COUNT,
} from './constants'

const updateLayerCount = (values, { layerCount }) => {
  return updateItemInArray(values, 0, 
    oldValue => updateObject(oldValue, { value: layerCount })
  )
}

const pcbLayerCountReducer = createReducer([], {
  [UPDATE_LAYER_COUNT]: updateLayerCount,
})

export default pcbLayerCountReducer
